/***
 * A custom directive that allows you to restrict an input type="text" to only allow numbers. The reason you might want
 * to use this instead of just doing <input type="number"> is because number inputs still allow you to enter an
 * arbitrary number of hyphen and period characters, which you might not want to be a valid character for your input.
 */
const numbersOnlyDirective = function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            ngModelCtrl.$parsers.push((text) => {
                if (text) {
                    const transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            });
        }
    };
};

export default numbersOnlyDirective;


// WEBPACK FOOTER //
// ./app/common/directives/numbers-only.directive.js